export const messages = {
  en: {
    staffAttendance: {
      monthPlaceholder: 'Select month',
      orgPlaceholder: 'Select organization',
      staffPlaceholder: 'Staff name',
      replenish: 'Replenish',
      work: 'Work',
      offWork: 'Off work',
      log: 'Attendance log',
      notTime: 'Not time yet',
      noNeed: 'No need',
      noTask: 'No replenish task',
      chooseOrg: 'Select Organization',
      loadOrgFailed: 'Failed to load organizations',
      selectOrgFirst: 'Please select an organization first',
      attendanceDetail: 'Attendance Details',
      staffName: 'Staff Name',
      face: 'Face',
      clockTime: 'Clock Time',
      loadDetailFailed: 'Failed to load attendance details',
      replenishCheckIn: 'Replenish Attendance',
      attendanceTask: 'Attendance Task',
      selectTask: 'Please select task',
      selectTaskFirst: 'Please select a task first',
      reason: 'Reason',
      inputReason: 'Please input reason',
      inputReasonFirst: 'Please input reason first',
      submitReplenish: 'Submit Replenish',
      replenishSuccess: 'Replenish successfully',
      replenishFailed: 'Replenish failed'
    }
  },
  zh: {
    staffAttendance: {
      monthPlaceholder: '请选择月份',
      orgPlaceholder: '请选择组织',
      staffPlaceholder: '员工名称',
      replenish: '补考勤',
      work: '上班',
      offWork: '下班',
      log: '考勤记录',
      notTime: '未到时间',
      noNeed: '无需考勤',
      noTask: '不存在补考勤任务',
      chooseOrg: '选择组织',
      loadOrgFailed: '加载组织失败',
      selectOrgFirst: '请先选择组织',
      attendanceDetail: '考勤明细',
      staffName: '员工名称',
      face: '人脸',
      clockTime: '考勤时间',
      loadDetailFailed: '加载考勤明细失败',
      replenishCheckIn: '补考勤',
      attendanceTask: '考勤任务',
      selectTask: '请选择考勤任务',
      selectTaskFirst: '请先选择考勤任务',
      reason: '原因',
      inputReason: '请填写原因',
      inputReasonFirst: '请先填写原因',
      submitReplenish: '提交补考勤',
      replenishSuccess: '补考勤成功',
replenishFailed: '补考勤失败'
    }
  },
  'zh-TW': {
    staffAttendance: {
      monthPlaceholder: '請選擇月份',
      orgPlaceholder: '請選擇組織',
      staffPlaceholder: '員工名稱',
      replenish: '補考勤',
      work: '上班',
      offWork: '下班',
      log: '考勤記錄',
      notTime: '未到時間',
      noNeed: '無需考勤',
      noTask: '不存在補考勤任務',
      chooseOrg: '選擇組織',
      loadOrgFailed: '加載組織失敗',
      selectOrgFirst: '請先選擇組織',
      attendanceDetail: '考勤明細',
      staffName: '員工名稱',
      face: '人臉',
      clockTime: '考勤時間',
      loadDetailFailed: '加載考勤明細失敗',
      replenishCheckIn: '補考勤',
      attendanceTask: '考勤任務',
      selectTask: '請選擇考勤任務',
      selectTaskFirst: '請先選擇考勤任務',
      reason: '原因',
      inputReason: '請填寫原因',
      inputReasonFirst: '請先填寫原因',
      submitReplenish: '提交補考勤',
      replenishSuccess: '補考勤成功',
      replenishFailed: '補考勤失敗'
    }
  }
}